export default __webpack_public_path__ + "9d6ff0542ea16982ae92efa676df3bf4.svg";